import { render, staticRenderFns } from "./specialGoods.vue?vue&type=template&id=3047872d&scoped=true"
import script from "./specialGoods.vue?vue&type=script&lang=js"
export * from "./specialGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3047872d",
  null
  
)

export default component.exports